const stylePatch = document.createElement('style');
stylePatch.innerHTML = `
  #recently-viewed-products .full-unstyled-link::after,
  #recently-view-card::after { box-shadow: none !important; content: none !important; }
  #recently-viewed-products .jdgm-widget { display: block !important; visibility: visible !important; opacity: 1 !important; min-height: 16px; }
  .recently-viewed-link { text-decoration: none; color: inherit; display: block; position: relative; z-index: 2; margin-top: 10px; }
  .recently-view-card-link { display: block; text-decoration: none; position: relative; width: 100%; }
  
  /* Hover 切换逻辑 */
  .recently-view-card .secondary-image { 
    opacity: 0; 
    transition: opacity 0.4s ease-in-out; 
    z-index: 2;
  }
  .recently-view-card-link:hover .secondary-image { 
    opacity: 1; 
  }
  .recently-view-card .primary-image {
    z-index: 1;
    transition: opacity 0.4s ease-in-out;
  }
`;
document.head.appendChild(stylePatch);

async function renderRecentlyViewed() {
  const container = document.querySelector('#recently-viewed-products');
  if (!container) return;

  const section = container.closest('.section') || container.closest('.shopify-section') || container.parentElement;
  let history = JSON.parse(localStorage.getItem('shopify-recently-viewed') || '[]');
  const currentHandle = container.dataset.currentHandle;

  if (currentHandle) {
    history = history.filter(h => h !== currentHandle);
    history.unshift(currentHandle);
    localStorage.setItem('shopify-recently-viewed', JSON.stringify(history.slice(0, 9)));
  }

  const displayHandles = history.filter(h => h !== currentHandle).slice(0, 8);

  if (displayHandles.length === 0) {
    if (section) {
      section.style.setProperty('display', 'none', 'important');
      section.classList.add('hidden');
    }
    return;
  }

  try {
    const langPath = window.Shopify.routes.root;
    const products = await Promise.all(
      displayHandles.map(handle => 
        fetch(`${langPath}products/${handle}.js`)
          .then(res => res.ok ? res.json() : null)
          .catch(() => null)
      )
    );

    const validProducts = products.filter(p => p !== null);
    if (validProducts.length === 0) {
      if (section) section.style.display = 'none';
      return;
    }

    container.innerHTML = validProducts.map(product => {
      const price = (product.price / 100).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2});
      const comparePrice = product.compare_at_price ? (product.compare_at_price / 100).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2}) : null;
      const symbol = window.Shopify.currency.symbol || '$';
      const currencyCode = window.Shopify.currency.active || ''; 
      const onSale = product.compare_at_price > product.price;
      
      // --- 关键修复：兼容不同格式的图片数组 ---
      const images = product.images || [];
      const getImgUrl = (img) => {
        if (!img) return '';
        return typeof img === 'string' ? img : (img.src || img.url || '');
      };

      const firstImg = getImgUrl(product.featured_image) || getImgUrl(images[0]);
      const secondImg = images.length > 1 ? getImgUrl(images[1]) : '';

      return `
        <li class="grid__item">
          <div class="card-wrapper product-card-wrapper underline-links-hover">
            <div class="card card--standard card--media">
              <a href="${product.url}" class="recently-view-card-link">
                <div class="recently-view-card" style="position: relative; width: 100%; aspect-ratio: 1/1; overflow: hidden; border-radius: 10px; background: transparent !important;">
                  <div class="media" style="width: 100%; height: 100%; position: relative; background: transparent !important;">
                    <img src="${firstImg}" 
                         class="motion-reduce primary-image" 
                         loading="lazy" 
                         width="300" height="300"
                         style="object-fit: cover; width: 100%; height: 100%; display: block; position: absolute; top:0; left:0;">
                    ${secondImg ? `
                      <img src="${secondImg}" 
                           class="motion-reduce secondary-image" 
                           loading="lazy" 
                           width="300" height="300"
                           style="object-fit: cover; width: 100%; height: 100%; display: block; position: absolute; top:0; left:0;">
                    ` : ''}
                  </div>
                  ${onSale ? `<div class="card__badge bottom left"><span class="badge badge--bottom-left color-accent-1">Sale</span></div>` : ''}
                </div>
              </a>
              <div class="card__content">
                <div class="card__information">
                  <h3 class="card__heading h5" style="margin-bottom: 5px;">
                    <a href="${product.url}" class="recently-viewed-link">${product.title}</a>
                  </h3>
                  <div class="jdgm-widget jdgm-preview-badge" data-id="${product.id}"></div>
                  <div class="price ${onSale ? 'price--on-sale' : ''}" style="margin-top: 5px;">
                    <div class="price__container">
                      ${onSale ? `
                        <div class="price__sale">
                          <s class="price-item price-item--regular" style="color: rgba(var(--color-foreground),.7); margin-right: 8px;">${symbol}${comparePrice} ${currencyCode}</s>
                          <span class="price-item price-item--sale price-item--last" style="color: rgb(var(--color-foreground));">${symbol}${price} ${currencyCode}</span>
                        </div>
                      ` : `
                        <div class="price__regular">
                          <span class="price-item price-item--regular" style="color: rgb(var(--color-foreground));">${symbol}${price} ${currencyCode}</span>
                        </div>
                      `}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </li>`;
    }).join('');

    if (section) section.style.display = 'block';

    // 唤醒 Judge.me
    if (window.jdgm && typeof window.jdgm.customizeWidgets === 'function') {
      window.jdgm.customizeWidgets();
      setTimeout(() => window.jdgm.customizeWidgets(), 1000);
    }

  } catch (err) {
    console.error('Recently Viewed Error:', err);
  }
}

document.addEventListener('DOMContentLoaded', renderRecentlyViewed);